import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Inbox, ShoppingBag, Users } from "lucide-react";
import { motion } from "framer-motion";

export const MessagesEmpty = ({ userRole }) => {
  const navigate = useNavigate();

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 }
    }
  };

  return (
    <motion.div variants={itemVariants} className="text-center py-10">
      <Card className="max-w-md mx-auto p-6 shadow-lg">
        <Inbox className="mx-auto h-16 w-16 text-primary mb-4" />
        <h2 className="text-2xl font-semibold mb-2">
          {userRole === "buyer" ? "No Messages Yet" : "No Customer Messages"}
        </h2>
        <p className="text-muted-foreground mb-6">
          {userRole === "buyer"
            ? "When you contact sellers about parts, your conversations will appear here."
            : "When buyers contact you about your parts, conversations will appear here."}
        </p>
        <Button
          onClick={() => navigate(userRole === "buyer" ? "/" : "/dashboard")}
        >
          {userRole === "buyer" ? (
            <>
              <ShoppingBag className="mr-2 h-4 w-4" /> Find Parts
            </>
          ) : (
            <>
              <Users className="mr-2 h-4 w-4" /> Go to Dashboard
            </>
          )}
        </Button>
      </Card>
    </motion.div>
  );
};
